import { styled } from '@mui/material/styles';

import { Box } from '../../../../components/atoms/Box';

import { COLORS } from '../../../../configs/colors';

export const ManifestBox = styled(Box)`
  width: 100%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;